import { render, staticRenderFns } from "./deliverers.vue?vue&type=template&id=a81865b4&%40keyup.esc=closeEverything&"
import script from "./deliverers.vue?vue&type=script&lang=js&"
export * from "./deliverers.vue?vue&type=script&lang=js&"
import style0 from "./deliverers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports